import styled from 'styled-components';

export default styled.span`
  color: black;
  grid-area: description;
  font-size: 0.8rem;
`;
